module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Slow Cooker Double Dinners for Two")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poultry ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken with Zucchini and Mushrooms\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e477",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken with Sweet Potatoes and Figs\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e550",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Southwest Chicken and White Bean Chili\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e605",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken with Parsnips and Apples ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e677",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Rustic Mexican Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e737",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken Curry with Red Potatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Curried Chicken Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e877",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Jerk Chicken and Sweet Potato Stew\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e945",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken and Olives ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Prosciutto-Wrapped Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Italian-Style Chicken Thighs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Barbecue Chicken Thighs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken Provençal ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1242",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Basque Chicken Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken with Mushroom Wine Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Bok Choy Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1442",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Indian Chicken Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1505",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken with Dried Fruit and Mustard\n                                    Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1627",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken with Plum Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1696",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken Marsala with Mushrooms and\n                                    Sage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1749",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chunky Chicken Soup with Garlic and\n                                    Thyme ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken Parmesan ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1879",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Raspberry Dijon Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1946",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Orange Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e1993",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Greek Isles Chicken Breasts ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chicken, Fennel, and Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Chicken with Artichokes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Pineapple Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Hoisin Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Turkey Breast Tenderloin with\n                                    Cranberry-Orange Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e2343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Kalamata Turkey Tenderloin with Greek\n                                    Seasoning ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2422",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Flank Steak with Green Beans and\n                                    Portabellas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Pepper Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Southwestern Flank Steak with A\n                                    Little Kick ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2626",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Flank Steak Fajitas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2700",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Mushroom-Stuffed Flank Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Red Wine Flank Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Rosemary Wine Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2876",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Beef Stew with Butternut Squash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2945",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Peppery Bottom Round ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e2996",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Fall-Flavored Bottom Round ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Pot Roast with Vegetables and Feta\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Old-Fashioned Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. India-Inspired Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Dilled Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Lime-Lemon Pot Roast with Tomato\n                                    Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Vinegar-Braised Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Sweet Tomato Pot Roast ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Horseradish Pot Roast with Vegetables\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3589",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Hoisin Short Ribs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3630",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Braised Short Ribs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3695",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Eye of Round in Marsala ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3749",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Eye of Round in Mustard Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Meatloaf ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Meatballs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3937",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Chutney Beef Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e3995",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Beef and Vegetable Stew with Ginger\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Spicy Mustard Beef Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Asian Beef Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Tomato-Based Beef Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Mushroom Beef Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Sirloin Tip with Mustard-Apple Sauce\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4358",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Sirloin Tip with Fall Vegetables ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Eat-In Chinese Beef ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e4485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Sirloin Tip with Red Bell Peppers\n                                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4566",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Cherry Balsamic Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4624",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Garlic Citrus Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Parmesan-Crusted Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4734",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. BBQ Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4804",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Brunswick Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4867",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Satay-Style Pork Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e4938",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Pork Stew with Gremolata ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Island Pork Chili ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Cumin-Lime Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Red Pepper Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Herb and Lemon Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Ginger Garlic Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Saged Pork with Figs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5360",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Pork Dijon with Fennel and Vegetables\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5427",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Garam Masala Pork ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Pork Tenderloin with Ginger-Mango\n                                    Sauce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5540",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Pork Tenderloin with Cabbage ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5591",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Jerk Pork Tenderloin ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5658",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Cranberry-Orange Pork Chops ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5717",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Asian Pork Chops ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5776",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Pork Stew with Green Beans and Yellow\n                                    Squash ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e5838",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Spicy Pork in Garlic Sauce ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamb ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5901",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Mediterranean Lamb and Olive Stew\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e5955",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Rockin’ Moroccan Lamb ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e6042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Asian Lamb with Eggplant ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e6096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Moroccan Spiced Lamb with Dried Fruit\n                                ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vegetarian ")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Red Lentil Stew ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Cauliflower and Bean Curry ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Vegetarian Chili ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. White Bean and Rice Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6424",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Ratatouille ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e6485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Apple and Vegetable Stew ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425e16fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01toc.vue
// module id = 63
// module chunks = 0